import { useEffect } from "react";
import { Paper } from "@mantine/core";
import { HiUsers } from "react-icons/hi2";
import { useGetMerchantProfile } from "../hooks/queries/useMerchantQueries";
import { useGetAllMerchantUsersQuery } from "../hooks/queries/useProfileQueries";
import { Headers } from "../components/ui/heading";
import DeveloperPage from "../components/Developer/DeveloperPage";

function Developer() {
  const { data: merchantProfile, isLoading, isError } = useGetMerchantProfile();
  const { data: merchantUsers } = useGetAllMerchantUsersQuery();

  useEffect(() => {
    import("../components/Docs/ApiReferencePage");
  }, []);

  const companyName =
    isLoading || isError
      ? "My Company"
      : merchantProfile?.merchantName || "My Company";

  return (
    <div className="-m-4 min-h-screen flex flex-col pb-16 bg-white-700">
      <Paper shadow="xs" p={{ base: "sm", sm: "xl" }}>
        <div className="flex-shrink-0 [&>div]:mb-0">
          <Headers
            name={companyName}
            additionalInfo={
              <span className="flex items-center gap-2 text-sm text-gray-600">
                <HiUsers className="text-lg" />
                {merchantUsers ? merchantUsers.length : 0} Users
              </span>
            }
          />
        </div>
      </Paper>
      <DeveloperPage />
    </div>
  );
}

export default Developer;
